module.exports = __webpack_public_path__ + "img/avatar0.c51cd13c.png";